import { useRef, useCallback } from "react";

export function useFocusNext() {
  const formRef = useRef<HTMLDivElement>(null);
  const lastFocusedInputRef = useRef<HTMLInputElement | null>(null);

  const focusNextInput = useCallback(() => {
    const lastInput = lastFocusedInputRef.current;
    requestAnimationFrame(() => {
      if (!formRef.current || !lastInput) return;
      const inputs = Array.from(
        formRef.current.querySelectorAll<HTMLInputElement>("input:not([disabled])"),
      );
      const i = inputs.indexOf(lastInput);
      if (i !== -1 && inputs[i + 1]) inputs[i + 1].focus();
    });
  }, []);

  return { formRef, lastFocusedInputRef, focusNextInput };
}
